import * as React from 'react';
import { observer } from 'mobx-react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { I18N_NS } from 'Config/i18n';
import { Loader } from 'Components/General/Loader';
import { AsyncTree } from 'Components/LibHelper/AsyncTree';
import { ModalComponentProps } from 'Components/General/Modal/ModalContext';
import { API } from 'General/API';
import { API_URL } from 'General/APIEndpoints';
import { projectsDataStore } from 'Stores';
import { Empty } from 'antd';

interface DocumentsSitemapProps extends ModalComponentProps, WithTranslation { }

interface DocumentsSitemapState {
  loading: boolean;
  data: API_TreeElement;
}

export const DocumentsSitemap = withTranslation(I18N_NS.PROJECT)(observer(
  class extends React.Component<DocumentsSitemapProps, DocumentsSitemapState> {

    constructor(props: DocumentsSitemapProps) {
      super(props);

      this.state = {
        data: {},
        loading: false,
      };
    }

    componentDidMount() {
      (async () => await this.fetch())();
    }

    fetch = async () => {
      try {
        this.setState({ loading: true });
        const response: API_TreeElement = await API.getData(API_URL.FOLDERS.getFullTree(projectsDataStore.projectId));
        this.setState({ data: response });
      } catch (error) {
        throw error;
      } finally {
        this.setState({ loading: false });
      }
    }

    render() {
      const { t } = this.props;
      const { loading, data } = this.state;
      if (loading) {
        return <Loader />;
      }

      return (
        <div>
          {data ? (
            <>
              <AsyncTree data={data} />
              {data.totalFiles && <small>* {t('files in current directory / total amount of files')}</small>}
            </>
          ) : <Empty />
          }
        </div>
      );
    }
  }));